export default __webpack_public_path__ + "../staticImages/sprite-packstation_small-2x.png";